let cachedStorage = null;
let storageResolved = false;

const resolveStorage = () => {
  if (storageResolved) {
    return cachedStorage;
  }

  storageResolved = true;

  if (typeof window === 'undefined') {
    cachedStorage = null;
    return cachedStorage;
  }

  try {
    if (!('localStorage' in window)) {
      cachedStorage = null;
      return cachedStorage;
    }

    const storage = window.localStorage;
    if (!storage) {
      cachedStorage = null;
      return cachedStorage;
    }

    const testKey = '__safe_storage_test__';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);

    cachedStorage = storage;
  } catch (error) {
    console.warn('localStorage unavailable:', error?.message || error);
    cachedStorage = null;
  }

  return cachedStorage;
};

const isBrowser = typeof window !== 'undefined';

const noop = () => {};

export const getLocalStorageItem = (key) => {
  if (!isBrowser) return null;
  const storage = resolveStorage();
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch (error) {
    console.warn('localStorage getItem failed:', error);
    return null;
  }
};

export const setLocalStorageItem = (key, value) => {
  if (!isBrowser) return;
  const storage = resolveStorage();
  if (!storage) return;
  try {
    storage.setItem(key, value);
  } catch (error) {
    console.warn('localStorage setItem failed:', error);
  }
};

export const removeLocalStorageItem = (key) => {
  if (!isBrowser) return;
  const storage = resolveStorage();
  if (!storage) return;
  try {
    storage.removeItem(key);
  } catch (error) {
    console.warn('localStorage removeItem failed:', error);
  }
};

export const clearLocalStorage = () => {
  if (!isBrowser) return;
  const storage = resolveStorage();
  if (!storage) return;
  try {
    storage.clear();
  } catch (error) {
    console.warn('localStorage clear failed:', error);
  }
};

export const withLocalStorage = (callback = noop) => {
  if (!isBrowser) return;
  const storage = resolveStorage();
  if (!storage) return;
  try {
    callback(storage);
  } catch (error) {
    console.warn('localStorage callback failed:', error);
  }
};

